import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Building2, ArrowRight } from 'lucide-react';
import { BrandHero, StatStrip, CtaBand } from '@/components/brand/BrandKit';
import { PersonalLease } from '@/components/leasing/PersonalLease';

const stats = [{ value: "1976", label: "Leasing expertise since" }, { value: "12 to 48", label: "Month terms" }, { value: "5% VAT", label: "Included in every rate" }, { value: "Fully", label: "Maintained & insured" }];

export default function LeasingPage() {
  useEffect(() => { document.title = "Personal Car Leasing UAE | Eurogulf Mobility Group, powered by Europcar"; }, []);

  return (
    <div data-testid="leasing-page">
      <BrandHero testid="leasing-hero" chip="Personal Leasing" title="Personal leasing, engineered for the way you drive." lead="Drive the vehicle you want without the hassles of ownership. Choose your car, lease term and mileage, and we take care of registration, insurance, servicing and roadside assistance, all in one simple monthly rate." image="/generated/personal-keys-handover.jpg" position="center 60%"
        ctas={[{ label: 'Request a Quote', href: '#personal-lease', testid: 'leasing-hero-cta' }, { label: '800 364', href: 'tel:800364', external: true, variant: 'outline' }]} />
      <StatStrip stats={stats} testid="leasing-stats" />

      <PersonalLease />

      {/* Corporate pointer */}
      <section data-testid="leasing-corporate-pointer" className="bg-[#FAFAFA] py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-2xl border border-black/5 bg-white p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5">
            <div className="flex items-start gap-4">
              <span className="grid h-12 w-12 place-items-center rounded-xl bg-[#EE5A01] text-white flex-shrink-0"><Building2 className="w-6 h-6" /></span>
              <div>
                <h3 className="font-heading font-bold text-lg text-[#121212]">Leasing for your business?</h3>
                <p className="mt-1 font-body text-sm text-[#666666] max-w-xl">Explore corporate rental and operational leasing for fleets of 5 to 500, with fleet management, telematics and replacement vehicles included.</p>
              </div>
            </div>
            <Link to="/corporate-rental-lease" data-testid="leasing-to-corporate" className="btn-primary w-fit flex-shrink-0">Corporate Rental &amp; Lease <ArrowRight className="w-4 h-4" /></Link>
          </div>
        </div>
      </section>

      <CtaBand title="Ready to start your personal lease?" desc="Tell us the vehicle you want and how you drive, and we will prepare your personalised quote." ctas={[{ label: 'Get a Quote', href: '#personal-lease', testid: 'leasing-cta' }, { label: 'WhatsApp Us', href: 'https://wa.me/971800364', external: true, variant: 'outline' }]} />
      <Link to="/europcar#leasing" className="sr-only">Europcar leasing</Link>
    </div>
  );
}
